import React, {useState} from 'react';
import {Popover} from 'antd';
import SuperLoggedInUserPopup from './SuperLoggedInUserPopup';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';

const SuperLoggedInUser = () => {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const handlePopoverVisibleChange = (visible) => {
    setPopoverVisible(visible);
  };

  return (
    <div className="w-full">
      <Popover
        content={<SuperLoggedInUserPopup />}
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={handlePopoverVisibleChange}
        placement="bottomLeft"
      >
        <div className="border-2 border-[#E9EAEB] rounded-xl w-full bg-white p-2 flex justify-between shadow-sm font-customFont">
          <div className="flex items-center">
            <div className="w-10 h-10 bg-[#F5F5F5] border border-[#E9EAEB] flex items-center justify-center rounded-full">
              <span className="text-xl text-[#535862] font-bold">
                {localStorage.getItem('name').charAt(0).toUpperCase() || 'U'}
              </span>
            </div>
            <div className="ml-3 flex flex-col">
              <p className="font-semibold text-black">
                {localStorage.getItem('name') || 'User Name'}
              </p>
              <p className="text-xs text-gray-500 break-all">
                {localStorage.getItem('email') || 'User Name'}
              </p>
            </div>
          </div>
          <div className="items-center flex">
            {popoverVisible ? (
              <i className="fa-solid fa-angle-up"></i>
            ) : (
              <i className="fa-solid fa-angle-down"></i>
            )}
          </div>
        </div>
      </Popover>
    </div>
  );
};

export default SuperLoggedInUser;
